import { makeStyles } from "@fluentui/react-components";

export const useTagsOptionsListStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
    width: "100%",
    maxHeight: "80vh",
  },
  option: {
    width: "100%",
    minWidth: "200px",
    padding: "3px",
    boxSizing: "border-box",
  },
});
